export default function(Mousetrap) {
    let _oldBind = Mousetrap.prototype.bind
    let argsBind

    Mousetrap.prototype.bind = function() {
        let self = this
        argsBind = arguments

        // normal call
        if (typeof argsBind[0] === 'string' || argsBind[0] instanceof Array) {
            return _oldBind.call(self, argsBind[0], argsBind[1], argsBind[2])
        }

        // object passed in
        for (let key in argsBind[0]) {
            if (argsBind[0].hasOwnProperty(key)) {
                let k = key.indexOf(',') === -1 ? key : key.split(',').map(i => i.trim())
                _oldBind.call(self, k, argsBind[0][key], argsBind[1])
            }
        }
    }

    let _oldBindGlobal = Mousetrap.prototype.bindGlobal
    let argsBindGlobal

    Mousetrap.prototype.bindGlobal = function() {
        let self = this
        argsBindGlobal = arguments

        // normal call
        if (typeof argsBindGlobal[0] === 'string' || argsBindGlobal[0] instanceof Array) {
            return _oldBindGlobal.call(self, argsBindGlobal[0], argsBindGlobal[1], argsBindGlobal[2])
        }

        // object passed in
        for (let key in argsBindGlobal[0]) {
            if (argsBindGlobal[0].hasOwnProperty(key)) {
                let k = key.indexOf(',') === -1 ? key : key.split(',').map(i => i.trim())
                _oldBindGlobal.call(self, k, argsBindGlobal[0][key], argsBindGlobal[1])
            }
        }
    }

    Mousetrap.init()

    return Mousetrap
}
